<div
  class="flex flex-nowrap justify-content-end align-items-center gs-toolbar"
  [class.gs-toolbar--compact-mobile]="isCompactMobile">
  @if (toolbarLayout === 'bottomBar') {
    <span
      class="np-informer-trigger gs-global-search-settings-trigger"
      [class.np-informer-trigger--open]="filterSettingsOpen"
      (click)="op.toggle($event)">
      <i
        class="pi pi-cog p-text-secondary"
        aria-hidden="true"></i>
    </span>
  } @else {
    <i
      class="pi pi-cog mx-3 my-3 text-xl cursor-pointer p-text-secondary"
      (click)="op.toggle($event)"></i>
  }

  <p-overlayPanel
    #op
    [style]="{ width: '150px' }"
    [styleClass]="filterSettingsOverlayStyleClass"
    (onShow)="onFilterSettingsOverlayShow()"
    (onHide)="onFilterSettingsOverlayHide()">
    <ng-template pTemplate="">
      <p-listbox
        [options]="filterSearch"
        [checkbox]="true"
        [multiple]="true"
        [showToggleAll]="false"
        dataKey="name"
        [(ngModel)]="selectedFilterSearch"
        [metaKeySelection]="false"
        [listStyle]="{ 'max-height': '350px' }"
        [style]="{ border: 'none' }"
        (ngModelChange)="changeFilterSearch($event)"></p-listbox>
    </ng-template>
  </p-overlayPanel>

  @if (!isCompactMobile) {
    <div
      class="gs-desktop-search w-full min-w-0"
      [class.gs-desktop-search--bottom-bar]="toolbarLayout === 'bottomBar'"
      (click)="onDesktopSearchShellClick($event)">
      <div class="w-full min-w-0">
        <crm-input-text
          #searchInput
          [(value)]="queryParams.q"
          (valueChange)="search.next($event)"
          [showClear]="true"
          [isInputIconLeft]="true"
          [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
          [placeholder]="searchPlaceholder"
          class="w-full"></crm-input-text>
      </div>
      @if (toolbarLayout === 'bottomBar') {
        <span
          class="gs-key-hint"
          aria-hidden="true">{{ shortcutOpenSearch }}</span>
      }
    </div>
  }

  @if (isCompactMobile) {
    <button
      type="button"
      class="gs-mobile-search-trigger mx-3 my-3 text-xl"
      aria-label="Поиск"
      (click)="openMobileSearchSheet()">
      <i class="pi pi-search"></i>
    </button>
  }
</div>

<p-dialog
  [(visible)]="mobileSearchOpen"
  header="Поиск"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  position="top"
  styleClass="gs-mobile-search-dialog"
  appendTo="body"
  [blockScroll]="true"
  (onShow)="onMobileSearchDialogShown()"
  (onHide)="onMobileSearchDialogHide()">
  <div class="p-input-icon-right w-full gs-mobile-dialog-input">
    <crm-input-text
      #mobileSearchInput
      [(value)]="queryParams.q"
      (valueChange)="search.next($event)"
      [showClear]="true"
      [isInputIconLeft]="true"
      [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
      [placeholder]="searchPlaceholder"
      class="w-full"></crm-input-text>
  </div>

  @if (searchResults$ | async; as results) {
    <div class="gs-mobile-results">
      <ng-container *ngTemplateOutlet="searchResultsTpl; context: { $implicit: results }"></ng-container>
    </div>
  }
</p-dialog>

@if (!isCompactMobile) {
  @if (searchResults$ | async; as results) {
    <div class="relative gs-desktop-results">
      <ng-container *ngTemplateOutlet="searchResultsTpl; context: { $implicit: results }"></ng-container>
    </div>
  }
}

<ng-template
  #searchResultsTpl
  let-results>
  <div
    #searchWindow
    pTooltip="Чтобы скрыть, нажмите на Esc"
    [showDelay]="300"
    tooltipPosition="top"
    class="search-results"
    [class.search-results--bottom-bar]="toolbarLayout === 'bottomBar'"
    [class.search-results--v2]="toolbarLayout === 'bottomBar'"
    [ngStyle]="toolbarLayout === 'bottomBar' ? desktopResultsPanelStyle : null">
    <div class="search-results__scroll">
    <div *ngIf="results.deals?.length">
      <div class="search-results__result-header fw-semibold"><i class="pi pi-briefcase text-base mr-2"></i>Сделки</div>
      <a
        *ngFor="let deal of results.deals"
        class="search-results__result"
        routerLink="/deal/card/{{ deal.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="deal.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="deal.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.projects?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-check-square text-base mr-2"></i>Задачи
      </div>
      <a
        *ngFor="let project of results.projects"
        class="search-results__result"
        routerLink="/project/card/{{ project.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="project.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="project.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.hdTasks?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-question-circle text-base mr-2"></i>HelpDesk
      </div>
      <a
        *ngFor="let task of results.hdTasks"
        class="search-results__result"
        routerLink="/helpdesk/task/card/{{ task.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="task.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="task.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.tasks?.length">
      <div class="search-results__result-header fw-semibold"><i class="pi pi-dollar text-base mr-2"></i>Платежи</div>
      <a
        *ngFor="let task of results.tasks"
        class="search-results__result"
        routerLink="/payments/task/card/{{ task.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="task.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="task.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.users?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-users text-base mr-2"></i>Пользователи
      </div>
      <a
        *ngFor="let user of results.users"
        class="search-results__result"
        routerLink="/user/card/{{ user.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="user.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="user.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.companies?.length">
      <div class="search-results__result-header fw-semibold"><i class="pi pi-building text-base mr-2"></i>Компании</div>
      <a
        *ngFor="let company of results.companies"
        class="search-results__result"
        routerLink="/company/my/card/{{ company.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="company.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="company.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div *ngIf="results.contragents?.length">
      <div class="search-results__result-header fw-semibold">
        <i class="pi pi-id-card text-base mr-2"></i>Контрагенты
      </div>
      <a
        *ngFor="let contragent of results.contragents"
        class="search-results__result"
        routerLink="/client/contragent/card/{{ contragent.id }}"
        target="_blank"
        (click)="closeSearchWindow()">
        <div [innerHTML]="contragent.title | highlight: queryParams.q | safeHtml"></div>
        <small
          class="text-gray-400"
          [innerHTML]="contragent.extra | searchTruncate: queryParams.q | highlight: queryParams.q | safeHtml"></small>
      </a>
    </div>

    <div
      *ngIf="
        !results.deals?.length &&
        !results.projects?.length &&
        !results.hdTasks?.length &&
        !results.tasks?.length &&
        !results.users?.length &&
        !results.companies?.length &&
        !results.contragents?.length
      "
      [class.inf-v2-empty]="toolbarLayout === 'bottomBar'"
      [class.p-3]="toolbarLayout !== 'bottomBar'"
      [class.fw-semibold]="toolbarLayout !== 'bottomBar'"
      [class.text-base]="toolbarLayout !== 'bottomBar'">
      <i class="pi pi-search mr-2"></i>Ничего не найдено
    </div>
    </div>
  </div>
</ng-template>
